// extracted by mini-css-extract-plugin
module.exports = {"HealthInsuranceGroup":"HealthInsuranceGroup_HealthInsuranceGroup__2GK6e"};